import React from "react";
import PropTypes from "prop-types";

import { PROJECT_PROFILE, PROJECT_TEAM } from "App/Routes";
import "./MobileProject.css";
import placeholder_team from "images/core/placeholders/placeholder_team.jpg";
import placeholder_project from "images/core/placeholders/placeholder_project.png";
import swipe_to_nav_image from "images/custom/project/fairprice-swipe-icon.png";
import MobileProjectPage from "components/Project/MobileProjectPage";
import SidebarLinks from "custom-components/shared/SidebarLinks/SidebarLinks";
import Link from "components/shared/Link/Link";

import localize from "lang/localize";

const propTypes = {
  project: PropTypes.object.isRequired,
  projectId: PropTypes.number,
  projectImage: PropTypes.string,
  buttons: PropTypes.array,
  topics: PropTypes.array.isRequired,
  user: PropTypes.object,
  team: PropTypes.object,
  categoryId: PropTypes.string,
  notifications: PropTypes.number.isRequired,
  inboxUnread: PropTypes.number.isRequired,
  more: PropTypes.bool,
  randomNumber: PropTypes.number.isRequired,
  flavorTextArr: PropTypes.array.isRequired,
  showcaseProject: PropTypes.object,
  addAnchors: PropTypes.func,
  handleMore: PropTypes.func,
  handleOpenShareGameDialog: PropTypes.func.isRequired,
  renderTopics: PropTypes.func,
  language: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleKeyPress: PropTypes.func,
  handleSearchChange: PropTypes.func,
  /* Custom: handler for opening tour modal */
  handleOpenTourModal: PropTypes.func
};

const defaultProps = {
  projectImage: placeholder_project
};

class CustomMobileProjectPage extends MobileProjectPage {
  /* Custom: removed text-shadow */
  renderProfilePointsLink(points) {
    if (this.props.user && this.props.user.id) {
      return (
        <Link to={PROJECT_PROFILE.format(this.props.projectId)}>
          <strong className="mobile-project-profile-points-text">
            {points.abbreviateNumber() + " "}
          </strong>
          <span className="mobile-project-points-text">
            {localize("points_just_text", this.props.language)}
          </span>
        </Link>
      );
    } else {
      return this.renderProfileLoginButton();
    }
  }

  /* Custom: removed text-shadow */
  renderProfileNameLink(name) {
    if (this.props.user && this.props.user.id) {
      return (
        <Link to={PROJECT_PROFILE.format(this.props.projectId)}>{name}</Link>
      );
    } else {
      return (
        <span className="text-shadow">
          {localize("require_login_view_profile", this.props.language)}
        </span>
      );
    }
  }

  renderMobileProjectHome() {
    let name = this.props.user ? this.props.user.name : "";
    let team = this.props.team;
    let teamImage = team && team.image ? team.image : placeholder_team;

    let points =
      this.props.user && this.props.user.points ? this.props.user.points : 0;

    return (
      <div key={"projecthome"} className="pure-u-g mobile-project-main">
        {/* Custom: use image instead of background, include text */}
        <div className="swipe-to-nav uppercase">
          <p className="bottommargin-10">
            {localize("swipe_to_navigate_text_start", this.props.language)}
            <br />
            {localize("swipe_to_navigate_text_end", this.props.language)}
          </p>
          <div className="flex justify-content-flexend">
            <img src={swipe_to_nav_image} className="imgresponsive" alt="" />
          </div>
        </div>
        <div className="mobile-project-sidebar">
          <div className="mobile-project-profile">
            <div className="pure-u-g mobile-project-profile-button-container">
              <div className="pure-u-7-24 profile-image-container">
                {this.renderProfileImageLink(name)}
              </div>
              {/* Custom: added name here */}
              <div className="pure-u-17-24 profile-name-container">
                <div className="mobile-project-profile-link text-truncated">
                  {this.renderProfileNameLink(name)}
                </div>
              </div>
              {this.renderMobileProjectInboxIcon()}
              {this.renderMobileProjectNotificationIcon()}
              {this.props.project &&
                this.props.project.teamEnabled &&
                team &&
                team.id && (
                  <div className="pure-u-4-24">
                    <Link
                      to={PROJECT_TEAM.format(this.props.projectId, team.id)}
                    >
                      <span className="square-image-wrapper">
                        <span className="square-image circle mobile-project-profile-button-border">
                          <img src={teamImage} alt="" />
                        </span>
                      </span>
                    </Link>
                  </div>
                )}
            </div>
            {/* Custom: removed name here */}
            <div className="mobile-project-profile-link text-truncated">
              {this.renderProfilePointsLink(points)}
            </div>
          </div>
          <SidebarLinks
            projectId={this.props.project.id}
            showTeams={this.props.project.teamEnabled}
            buttons={this.props.buttons}
            language={this.props.language}
            /* Custom: handler for opening tour modal */
            handleOpenTourModal={this.props.handleOpenTourModal}
          />
        </div>
      </div>
    );
  }
}

CustomMobileProjectPage.propTypes = propTypes;
CustomMobileProjectPage.defaultProps = defaultProps;

export default CustomMobileProjectPage;
